import { getTranslation } from '@easy-expense/intl-client';
import React from 'react';

import { CurrencyField } from './CurrencyInput.component';

export const TipField: React.FC<{
  tip?: number | null;
  onChange: (tip: number | null) => void;
  renderKey?: string;
}> = ({ tip, onChange, renderKey }) => {
  return (
    <CurrencyField
      key={`tip_${renderKey}`}
      onChange={(value) => onChange(value > 0 ? value : null)}
      initialValue={tip ?? undefined}
      updatedValue={tip ?? undefined}
      label={getTranslation('Tip')}
      showCurrency={false}
    />
  );
};
